// Українська - uk - 乌克兰语
const uk = {
  home: {
    home: 'Головна',
    solutions: 'Рішення',
    support: 'Підтримка',
    news: 'Новини',
    aboutUs: 'Про нас',
    contactUs: 'Контакти',
    cgm: 'CGM',
    download: 'Завантаження',
    helpCenter: 'Центр допомоги',
    copyText: '© 2026 HIPPO MEDICAL PTE. LTD. Усі права захищені.',
    menu: 'Меню',
    quickLinks: 'Швидкі посилання',
    contact: 'Контакти',
    legal: 'Юридична інформація',
    termsUse: 'Умови використання',
    privacyPolicy: 'Політика конфіденційності',
    portal: 'Портал користувача',
    hClinic: 'H-Clinic',
    emailPlaceholder: 'Електронна пошта',
    subscribe: 'Підписатися',
    signUp: 'Підпишіться, щоб отримувати останні новини',
    downloadApp: 'Завантажити додаток',
    blogNews: 'Блог та новини',
    latestArticles: 'Останні статті',
    viewAllArticles: 'Переглянути всі статті',
    empower: "Контролюйте свій шлях до здоров'я разом із нами",
    empowerList1Content:
      'Hippo CGM значно полегшив контроль діабету у мого сина. Ми можемо використовувати HIPPOLINK, щоб чітко бачити його показники глюкози та впевнено коригувати лікування. Це дарує нам спокій.',
    empowerList1Name: 'Petra N., Чехія (мати дитини з діабетом 1 типу)',
    empowerList2Content:
      'Ми рекомендуємо HIPPO CGM пацієнтам завдяки його стабільній роботі та тривалому часу носіння. Відгуки користувачів дуже позитивні, особливо серед тих, хто шукає більш доступне рішення.',
    empowerList2Name: 'Dr. Luca B., ендокринолог, Італія',
    empowerList3Content:
      'Нещодавно я почав користуватися Hippo CGM — він комфортний, точний, а сповіщення допомагають мені уникати низького рівня глюкози вночі. Поки що я дуже задоволений результатами.',
    empowerList3Name:
      'Fahad A., Саудівська Аравія (пацієнт із діабетом 2 типу)',
    reliable: 'Ваш надійний партнер у контролі діабету',
    hippoH1: 'HIPPO H1',
    challenges: 'Виклики',
    constant: 'Постійний контроль рівня глюкози',
    traditional:
      'Традиційні проколи пальця для вимірювання рівня глюкози можуть бути болісними та незручними',
    dataOverload: 'Перевантаження даними',
    managing:
      'Керування даними про рівень глюкози з різних джерел може бути складним і перевантажувати',
    treatment: 'Корекція лікування',
    accurately:
      'Точне визначення правильних дій на основі показників глюкози може бути складним',
    lifestyle: 'Інтеграція у спосіб життя',
    balancing:
      'Поєднання харчування, фізичної активності та медикаментів із повсякденним життям може бути викликом',
    hippoCan: 'Що пропонують Hippo Biosensors',
    painless: 'Безболісний та непомітний моніторинг',
    ourCgm:
      'Наші CGM забезпечують безперервний моніторинг рівня глюкози без необхідності проколювання пальця',
    realTime: 'Дані та аналітика в реальному часі',
    accessYour:
      'Отримуйте доступ до даних про рівень глюкози зі смартфона, щоб бачити тенденції та приймати обґрунтовані рішення',
    personalized: 'Персоналізована підтримка',
    ourCgmSys:
      'Сповіщення та нагадування від додатка Hippo BioSensors допоможуть вам дотримуватися плану лікування',
    improved: 'Покращене прийняття рішень',
    gain: "Глибше розуміння того, як ваш організм реагує на різні фактори, допомагає краще компенсувати коливання рівня глюкози. Зворотний зв'язок у реальному часі дозволяє ефективніше коригувати щоденні дії.",
    // about: 'Про компанію',
    companyProfile: 'Профіль компанії',
    banner1Title: 'Ласкаво просимо до Hippo Medical',
    banner1Content: 'На передовій інновацій CGM',
    get banner2Title() {
      return this.banner1Title;
    },
    banner2Content: 'Встановлюємо нові стандарти в технологіях CGM',
    banner3Content: 'Цілодобовий захист рівня глюкози',
    get banner4Title() {
      return this.banner1Title;
    },
    banner4Content: 'Лідер у технологіях CGM',
    // 错误提示
    subscribeSuccess: 'Підписку успішно оформлено', // ai翻译
    subscribeFailed: 'Не вдалося оформити підписку', // ai翻译
    invalidEmail: 'Недійсна адреса електронної пошти', // ai翻译
  },
  cgm: {
    get banner1Title() {
      return uk.home.banner1Title;
    },
    get banner1Content() {
      return uk.home.banner4Content;
    },
    whyChoose: 'Чому обирають HIPPO CGM',
    accurate: 'Точність, якій можна довіряти',
    accurateText:
      'Технологія ферментів третього покоління забезпечує більш стабільну та точну роботу',
    accurateText1: 'Більш стабільна та точна ефективність',
    easyUse: 'Простий у використанні',
    easyUseText: '14 днів безперервного моніторингу',
    realTime: 'Моніторинг у реальному часі',
    realTimeText: 'Сповіщення про гіпо- та гіперглікемію в реальному часі',
    realTimeText1:
      'Обмін даними в реальному часі з членами родини та медичними працівниками',
    hippo: 'HIPPO',
    hCgm: 'H1 CGM',
    keep: 'Будьте поінформовані будь-де та будь-коли',
    withHippo: 'З додатками та порталом HIPPO',
    smallSensors: 'Компактні сенсори, комфортні у носінні',
    agpReport:
      'Професійний AGP-звіт дозволяє лікарям та користувачам миттєво отримувати ключову інформацію',
    unlimitedFollow:
      'Необмежене відстеження — допомагає лікарям вести більше пацієнтів',
    iWatchApp: 'Доступний додаток iWatch',
    certified: 'Сертифіковано для дітей',
    loremIp:
      'Система клінічно валідована та офіційно сертифікована для використання дітьми від 3 років, що забезпечує безпеку, точність і комфорт для маленьких пацієнтів. Завдяки підтвердженій точності сенсора та делікатним для шкіри матеріалам система забезпечує надійний моніторинг глюкози для дітей та підлітків, допомагаючи медичним працівникам надавати впевнену та сучасну допомогу при діабеті.',
  },
  news: {
    date: 'Дата',
    recommendedArticles: 'Рекомендовані статті',
  },
  support: {
    download: 'Завантажити інструкції',
    supportDown: 'Підтримка / Завантаження',
  },
  about: {
    // welcome: 'Ласкаво просимо до Hippo Medical',
    // covered: 'Країни присутності',
    // patents: 'Патенти',
    // features: 'Особливості3',
    // ring: 'Кільце',
    // apparently:
    //   'Інноваційне кільце, яке може відстежувати такі показники, як рівень кисню в крові, серцевий ритм і сон. Найважливіше — воно має алгоритмічну інтеграцію з нашою системою CGM. Запуск у 2026 році. Слідкуйте за оновленнями!',
    // cgmSky:
    //   'Професійна CGM-система, розроблена як для пацієнтів, так і для клінічних потреб лікарів. Вона забезпечує високу точність, зручний програмний інтерфейс і працює на алгоритмах Hippo Medical. Запуск у червні 2025 року!',
    // smartWatch: 'Смарт-годинник',
    // byTheSame:
    //   'Носимий пристрій для динамічного моніторингу артеріального тиску, який може безперервно відстежувати систолічний, діастолічний та середній артеріальний тиск і багато іншого, використовуючи алгоритм, розроблений Hippo Medical. Запуск у 2026 році. Слідкуйте за оновленнями!',
    explore: 'Дізнатися більше',
    hippoPte: 'HIPPO MEDICAL PTE. LTD.',
    paya: '60 PAYA LEBAR ROAD',
    lebar: '#11-53',
    road: 'PAYA LEBAR SQUARE',
    singa: 'СІНГАПУР (409051)',
    zipCode: 'Поштовий індекс',
    emailCode: '409051',
    email: 'Електронна пошта',
    emailText: 'info@hippodiabetes.com',
    name: "Ім'я*",
    company: 'Компанія',
    message: 'Повідомлення',
    phone: 'Телефон',
    submit: 'Надіслати',
    // commingSoon: 'Незабаром',
    cpInfo1:
      'Hippo Medical — глобальна MedTech-компанія зі штаб-квартирою в Сінгапурі, яка займається революційними рішеннями у сфері контролю хронічних захворювань за допомогою медичних носимих біосенсорів. Наше бачення — забезпечити безперервний моніторинг та передову аналітику даних.',
    cpInfo2:
      'Розробляючи біосенсори нового покоління та інноваційну платформу аналізу даних, ми прагнемо трансформувати діагностику та прокласти шлях до більш проактивного й персоналізованого майбутнього.',
    submitFailed: 'Не вдалося надіслати', // ai翻译
    get invalidEmail() {
      return uk.home.invalidEmail;
    },
    fillAllFields: 'Будь ласка, заповніть це поле', // ai翻译
  },
  download: {
    language: 'Мова',
    product: 'Продукт',
    unit: 'Пристрій',
    fetchFailed: 'Не вдалося отримати дані', // ai翻译
  },
  help: {
    search: 'Пошук',
    support: 'Підтримка / Центр допомоги / H1 CGM',
    source: 'Онлайн-ресурси HIPPO H1 CGM',
    viewAll: 'Переглянути всі',
    insert: 'Як встановити ваш H1 CGM',
    setUp: 'Як налаштувати додаток H1',
    faq: 'FAQ HIPPO H1 CGM',
    freq: 'Поширені запитання',
    noData: 'Контент не знайдено.',
    searchKeys: {
      warmUp: 'Помилка фази прогріву',
      waterLeakage: 'Потрапляння води',
      lowGlucose: 'Низький рівень глюкози',
      cannotPair: 'Неможливо підключити пристрій до смартфона',
    },
  },
  faq: {
    faq: 'FAQ',
    general: 'Загальні питання',
    need: 'Потрібна допомога?',
    here: 'Тут зібрані  найпоширеніші запитання',
    technical: 'Технічні питання',
  },
  lang: {
    chooseCountry: 'Оберіть вашу країну / регіон',
    northAmerica: 'Північна Америка', // ai翻译
    southAmerica: 'Південна Америка', // ai翻译
    europe: 'Європа', // ai翻译
    africa: 'Африка', // ai翻译
    asia: 'Азія', // ai翻译
    oceania: 'Океанія', // ai翻译
    other: 'Інші', // ai翻译
  },
  aboutMap: {
    suzhou: {
      name: 'Сучжоу, Китай',
      subName: 'Вир. майданчик',
      hovData:
        'Глобальна штаб-квартира R&D / Центр обробки даних / Офіс продажів для Азії та Австралії',
    },
    dubai: {
      name: 'Дубай',
      subName: 'Регіональний офіс',
      hovData: 'Команда продажів HQ Південно-Східної Азії',
    },
    singapore: {
      name: 'Сінгапур',
      subName: 'Штаб-квартира',
      hovData: 'Команда продажів Південно-Східної Азії',
    },
    sanFrancisco: {
      name: 'Сан-Франциско, США',
      subName: 'Регіональний офіс',
      hovData: 'Команда продажів HQ Північної Америки',
    },
    barcelona: {
      name: 'Барселона',
      subName: 'Офіс продажів',
      hovData:
        'Глобальна штаб-квартира R&D / Центр обробки даних / Офіс продажів для Азії та Австралії',
    },
  },
};
export default uk;
